var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.oldHtml == true ? 'oldCss' : '',attrs:{"id":"app"}},[_c('el-container',[_c('el-main',{staticClass:"sys-main"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }